<template>
  <b-row>
    <b-col cols="12" xl="9">
      <news-search-form
        :pagination="pagination"
        @clicked="onSearchClick"
        @change="onSearchResult"
      ></news-search-form>
    </b-col>
    <b-col cols="12" xl="3">
      <b-button v-on:click="goToAddNews">Add News</b-button>
    </b-col>
    <b-col cols="12" xl="12">
      <b-card>
        <div slot="header">
          <strong>News</strong>
        </div>
        <transition name="slide">
          <pagination-table
            :items="news"
            :fields="[
                  {key: 'name'},
                  {key: 'status'},
                  {key: 'publishedAt'},
                  {key: 'actions'},
                ]
            "
            :pagination="pagination"
            :is-loading="isLoading"
            item-url="news/{id}"
          >
          </pagination-table>
        </transition>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
  import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";
  import {PaginationMeta} from "../../models/PaginationMeta";
  import NewsSearchForm from "../../components/News/NewsSearchForm";
  import PaginationTable from "../../components/base/PaginationTable";

  export default {
      name: 'news',
      components: {
        PaginationTable,
        NewsSearchForm
      },
      data: () => {
        return {
          news: [],
          pagination: new PaginationMeta(),
          isLoading: true,
          searchParams: {},
        }
      },
      mounted () {
        RepositoryFactory
          .get('news')
          .get()
          .then(
            response => (
                this.news = response.data.data,
                this.pagination = response.data.meta,
                this.isLoading = false
            )
          )
      },
      methods: {
        onSearchResult (response) {
            this.news = response.data,
            this.pagination  = response.meta,
            this.isLoading   = false
        },
        onSearchClick(params) {
          this.isLoading = true
          this.searchParams = params
        },
        goToAddNews() {
          router.push({name: 'news-add'})
        },
      }
  }
</script>
